import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { translateError } from "@/i18n/errors";

export const AiSwitchCard = () => {
  const { t } = useI18n();
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/settings/ai").then(({ data }) => setInfo(data)).catch(() => {});
  }, []);

  const toggle = async (enabled) => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/settings/ai", { enabled });
      setInfo(data);
      toast.success(t(enabled ? "ai.toastOn" : "ai.toastOff"));
    } catch (err) {
      toast.error(translateError(err, t));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="card-carbon rounded-2xl p-6" data-testid="ai-switch-card">
      <div className="flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wider text-white">
          <Sparkles className="h-5 w-5 text-[var(--gold)]" /> {t("ai.switchTitle")}
        </h2>
        {info && <Switch checked={info.enabled} disabled={busy} onCheckedChange={toggle} data-testid="ai-switch" />}
      </div>
      <p className="mt-2 text-sm text-neutral-400">{t("ai.switchHint")}</p>
      {info && (
        <p className="mt-3 text-xs">
          <span className={`rounded-full px-2.5 py-1 font-bold uppercase ${info.enabled ? "bg-[var(--gold)] text-black" : "border border-neutral-600 text-neutral-400"}`} data-testid="ai-switch-status">
            {t(info.enabled ? "ai.on" : "ai.off")}
          </span>
        </p>
      )}
    </section>
  );
};
